/**
 * Pending-claim token instalacji shop-first Shopify (VP-255).
 *
 * Strona claim odkłada token w localStorage, gdy niezalogowany merchant idzie
 * na login/rejestrację; router (App.tsx) po zalogowaniu sprawdza ten token
 * i wraca na /integracje/shopify/claim, żeby domknąć podpięcie sklepu.
 *
 * Wydzielone z pages/shopify-claim.tsx, żeby App.tsx nie importował
 * lazy-chunka strony (statyczny import z tego modułu scaliłby chunk z main).
 */
const CLAIM_TOKEN_STORAGE_KEY = "shopify_pending_claim_token";

export function getPendingShopifyClaimToken(): string | null {
  try {
    return localStorage.getItem(CLAIM_TOKEN_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setPendingShopifyClaimToken(token: string): void {
  try {
    localStorage.setItem(CLAIM_TOKEN_STORAGE_KEY, token);
  } catch {
    /* tryb prywatny bez localStorage — merchant wróci przez link po instalacji */
  }
}

export function clearPendingShopifyClaimToken(): void {
  try {
    localStorage.removeItem(CLAIM_TOKEN_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
